import { required, TextInput } from "react-admin";
import { Grid } from "@mui/material";

const validateExactLength = length => value => {
  if (!value) return "Задължително"; // Ensures it's not empty
  if (value.length !== length) return `Полето трябва да е точно ${length} символа`;
  return undefined;
};

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="IBAN"
          source="ibanNumber"
          validate={validateExactLength(22)}
        />
      </Grid>
      <Grid
        item
        md={2}
        xs={12}
      >
        <TextInput
          label="BIC код за плащане в лева"
          source="bic"
          validate={validateExactLength(8)}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="BIC код за плащане във валута"
          source="bicForeign"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="SWIFT код"
          source="swiftCode"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="Банков код"
          source="bankCode"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="Име на банка"
          source="bankName"
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на получател на български език"
          source="recipientNames"
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на получател на английски език"
          source="recipientNamesEn"
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
